import clsx from "clsx"
import { AnimatePresence } from "framer-motion"
import { Fragment, memo } from "react"
import { EnergyPassportProductRow } from "@/features/energy-passport/ui/main-table/components/energy-passport-product-row.tsx"
import { EnergyPassportQuarterRow } from "@/features/energy-passport/ui/main-table/components/energy-passport-quarter-row.tsx"
import { useEnergyPassportStore } from "@/features/energy-passport/ui/main-table/model/store.ts"
import { TableChildRowsHeader } from "@/shared/components/common/table/table-child-rows-header.tsx"

export const EnergyPassportQuarterTable = memo(() => {
  // Store
  const { quarters } = useEnergyPassportStore()

  return (
    <table className={clsx("base-table")}>
      <TableChildRowsHeader />
      <tbody>
        {quarters?.map((quarterRow, quarterIndex) => {
          return (
            <Fragment key={quarterIndex}>
              <EnergyPassportQuarterRow quarterRow={quarterRow} />
              <AnimatePresence initial={false}>
                {quarterRow.expanded &&
                  quarterRow.products?.map((product, index) => {
                    return (
                      <EnergyPassportProductRow
                        key={index}
                        product={product}
                        quarterRow={quarterRow}
                        productLength={quarterRow.products.length}
                        index={index}
                      />
                    )
                  })}
              </AnimatePresence>
            </Fragment>
          )
        })}
      </tbody>
    </table>
  )
})
